import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    useStyleConfig,
    Box,
    Spinner,
    IconButton,
    Text
} from '@chakra-ui/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {useIntl} from 'react-intl'
import useFetchLibraryFolders from '../../hooks/useFetchLibrary'
import {
    sizeGuideModalBody,
    sizeGuideModalCloseButton,
    sizeGuideModalContent,
    sizeGuideModalDesc,
    sizeGuideModalHeader,
    sizeGuideStyle,
    spinnerStyle
} from './index.style'
import PropTypes from 'prop-types'

function SizeGuide(props) {
    const {isOpen, onClose, sizeGuideContentId} = props
    const styles = useStyleConfig('SwatchGroup')
    const intl = useIntl()

    const {
        data: {c_body, name, description},
        loading,
        error
    } = useFetchLibraryFolders(`content/${sizeGuideContentId}`)

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size={'4xl'}>
                <ModalOverlay />
                <ModalContent sx={sizeGuideModalContent}>
                    <IconButton
                        icon={
                            <img
                                src={getAssetUrl('static/img/modalCloseButton.png')}
                                height="15"
                                width="15"
                                alt="Cavender's"
                            />
                        }
                        {...styles.logoIcon}
                        variant="unstyled"
                        onClick={onClose}
                        sx={sizeGuideModalCloseButton}
                    />
                    {loading && !error ? (
                        <Spinner
                            data-testid="loading"
                            thickness="4px"
                            speed="0.65s"
                            emptyColor="gray.200"
                            color="blue.600"
                            size="xl"
                            sx={spinnerStyle}
                        />
                    ) : (
                        <>
                            <ModalHeader sx={sizeGuideModalHeader}>
                                {intl.formatMessage({
                                    id: 'pdp.sizeGuideTitle',
                                    defaultMessage: 'SIZE GUIDE:'
                                })}{' '}
                                {name ? name : ''}
                            </ModalHeader>
                            {description ? <Text sx={sizeGuideModalDesc}>{description} </Text> : ''}
                            <ModalBody sx={sizeGuideModalBody}>
                                <Box sx={sizeGuideStyle}>
                                    <Box dangerouslySetInnerHTML={{__html: c_body}}></Box>
                                </Box>
                            </ModalBody>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    )
}

SizeGuide.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    sizeGuideContentId: PropTypes.string.isRequired
}

export default SizeGuide
